<template>
  <div>
    <Head title="Create User" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-blue-400 hover:text-blue-600" href="/users">Users</Link>
      <span class="text-blue-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-2xl bg-white  shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="First name" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Last name" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" type="tel" label="Phone" mask="(###) ###-####" placeholder="Phone number" name="phone" />
          <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/2" type="password" autocomplete="new-password" label="Password" />
          <select-input v-model="form.role" :error="form.errors.role" class="pb-8 pr-6 w-full lg:w-1/2" label="Role">
            <option v-for="role in roles" :key="role.value" :value="role.value"> {{ role.key }}</option>
          </select-input>
          <select-input v-model="form.custom_run" :error="form.errors.custom_run" class="pb-8 pr-6 w-full lg:w-1/2" label="Custom Run">
            <option :value="true">Yes</option>
            <option :value="false">No</option>
          </select-input>
          <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Photo" />
          <select-input v-model="form.company" :error="form.errors.company" class="pb-8 pr-6 w-full" label="Company">
            <option value="null" disabled selected>Choose a company</option>
            <option v-for="c in companies" :key="c.id" :value="c.id"> {{ c.name }}</option>
          </select-input>
          <div class="w-full mb-4">
            <label class="form-label text-bold">Teams</label>
            <div class="grid grid-cols-4">
              <div v-for="team in company.teams" :key="team.id">
                <input v-model="form.teams" type="checkbox" :value="team.id" />
                <span class="text-sm px-2">{{ team.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-blue" type="submit">Create User</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    companies: Array,
    roles    : Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        first_name: '',
        last_name : '',
        email     : '',
        phone     : null,
        password  : '',
        role     :  null,
        custom_run: false,
        company   : null,
        photo     : null,
        teams     : [],
      }),
    }
  },
  computed:{
    company() {
      if (this.form.company) {
        return this.companies.find(c => c.id == this.form.company)
      }

      return {}
    },
  },
  methods: {
    store() {
      this.form.post('/users')
    },
  },
}
</script>
